export const CONTENT_HEADERS = {
    DEFAULT: 'Invoice List',
    GROUPED: {
        project: 'Project List',
        section: 'Section List',
        po: 'Purchase Order List',
        supplier: 'Supplier List',
        month: 'Monthly Invoice Summary',
        quarter: 'Quarterly Invoice Summary',
        none: 'Invoice List', // Explicitly define for 'none' group
    },
    SUB_TABLE: {
        po: 'Purchase Order List', // This is for the PO Details Table when drilling down
        invoices: 'Invoice List', // This is for Invoice Details Table when drilling down
        supplierInvoices: (label) => `Invoices for ${label}`,
        monthInvoices: (label) => `Invoices for ${label}`,
        quarterInvoices: (label) => `Invoices for ${label}`,
    },
};